import { declareString } from "@1js/localization";

export const SeeAllButtonLabel = declareString("promptLibrary.seeAllApps", {
  text: "See all",
  comment: `Label for a button that when clicked will show all Microsoft apps we currently support with Copilot in a section`,
});
